import _ from "lodash";

interface Component { refetch:()=>void }
class ForumDeletionEvent{
    private data: Component[];
    
    constructor(){
      this.data = [];
    }
  
    public add(component: Component){
      this.data.push(component);
    }
  
    public remove(component: Component){
        _.remove(this.data,(c)=>c==component);
    }
    public notify(){
        this.data.forEach((c) => c.refetch());
    }
  }
  
  const forumDeletionEvent = new ForumDeletionEvent();
  Object.freeze(forumDeletionEvent);
  
  export default forumDeletionEvent;


// WEBPACK FOOTER //
// ./src/panels/forum/ForumDeletionEvent.ts